import { render } from "./YesNoPopUp.vue?vue&type=template&id=b61f6768&scoped=true"
import script from "./YesNoPopUp.vue?vue&type=script&lang=js"
export * from "./YesNoPopUp.vue?vue&type=script&lang=js"

import "./YesNoPopUp.vue?vue&type=style&index=0&id=b61f6768&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61f6768"]])

export default __exports__